<template>
  <v-layout wrap fill-height class="tile-background">
    <v-flex xs12 :md8="isEdit" :lg7="isEdit" :xl8="isEdit" class="tile-content">
      <v-component :is="tileComponent" :value="value" :isFirst="isFirst" :isLast="isLast" />
    </v-flex>
    <v-flex v-show="isEdit" xs12 md4 lg5 xl4 align-self-center :style="{'display': 'flex', 'justify-content':'end', 'flex-wrap': 'wrap'}">
      <EditButton small class="edit-action-button" @click="onEdit" :disabled="loadingDelete">Edit</EditButton>
      <DeleteButton small class="edit-action-button" @click="onDelete" :loading="loadingDelete">Delete</DeleteButton>
      <div class="edit-action-button">
        <v-btn icon small dark color="secondary" :disabled="isFirst || isReorderingItems" @click="moveUp">
          <v-icon>keyboard_arrow_up</v-icon>
        </v-btn>
        <v-btn icon small dark color="secondary" :disabled="isLast || isReorderingItems" @click="moveDown">
          <v-icon>keyboard_arrow_down</v-icon>
        </v-btn>
      </div>
    </v-flex>
    <StaticContentFormModal :value="value" :tenant-name="tenantName" ref="formModal" />
    <ConfirmationDialog2 ref="deleteConfirmation" />
  </v-layout>
  <!-- <ExternalLinkTile :value="value" :isFirst="isFirst" :isLast="isLast" /> -->
</template>
<script>
  import ExternalLinkTile from '@/components/LandingPageStaticContent/TileTypes/ExternalLinkTile'
  import GenericTile from '@/components/LandingPageStaticContent/TileTypes/GenericTile'
  import StaticContentFormModal from '@/components/LandingPageStaticContent/Form/StaticContentFormModal'
  import {
    createNamespacedHelpers,
  } from 'vuex'
  import { INVALID_TEMPLATE_ID } from '@/store/landingPageStaticContent'
  const app = createNamespacedHelpers('app')
  const landingPageStaticContent = createNamespacedHelpers('landingPageStaticContent')
  export default {
    components: {
      GenericTile,
      ExternalLinkTile,
      StaticContentFormModal,
    },
    props: {
      tenantName: {
        type: String,
        default: '',
      },
      value: {
        type: Object,
        required: true,
      },
      isFirst: {
        type: Boolean,
        default: false,
      },
      isLast: {
        type: Boolean,
        default: false,
      },
      isEdit: {
        type: Boolean,
        default: false,
      },
    },
    data() {
      return {
        addNewStaticItem: false,
        loadingDelete: false,
      }
    },
    computed: {
      ...landingPageStaticContent.mapGetters(['getTemplateIdByName']),
      ...landingPageStaticContent.mapState(['isReorderingItems']),
      tileComponent() {
        return this.getTileByTemplateId(this.value.TemplateId)
      },
    },
    methods: {
      ...app.mapActions(['setSnackbar']),
      ...landingPageStaticContent.mapActions([
        'deleteStaticContentItem',
        'moveStaticContentItemUp',
        'moveStaticContentItemDown',
      ]),
      getTileByTemplateId(templateId) {
        switch (templateId) {
        case INVALID_TEMPLATE_ID:
          return GenericTile
        case this.getTemplateIdByName('External Link'):
          return ExternalLinkTile
        default:
          return GenericTile
        }
      },
      async onDelete() {
        try {
          this.loadingDelete = true
          const params = {
            title: 'Remove static content item?',
            text: '<div>This will remove the static content item.<br/> <div><strong>Note:</strong> If removed, the item will not be recoverable</div>',
            confirmText: 'Remove',
            cancelText: 'Cancel',
            color: 'error',
            icon: 'delete_forever',
          }
          const confirm = await this.$refs.deleteConfirmation.confirm(params)
          if (!confirm) {
            return
          }
          await this.deleteStaticContentItem({ contentItemId: this.value.Id, tenantName: this.tenantName })
          this.setSnackbar({
            text: 'Deleted static content item successfully',
            icon: 'done',
            color: 'success',
          })
        } catch (ex) {
          this.setSnackbar({
            text: `Failed to delete static content item: ${ex}`,
            icon: 'error',
            color: 'error',
          })
        } finally {
          this.loadingDelete = false
        }
      },
      onEdit() {
        this.$refs.formModal.show()
      },
      async moveUp() {
        try {
          await this.moveStaticContentItemUp({ contentItemId: this.value.Id, tenantName: this.tenantName })
          this.setSnackbar({
            text: 'Updated static content item order successfully',
            icon: 'done',
            color: 'success',
          })
        } catch (ex) {
          this.setSnackbar({
            text: `Failed to update static content item ordering: ${ex}`,
            icon: 'error',
            color: 'error',
          })
          console.error(ex)
        }
      },
      async moveDown() {
        try {
          await this.moveStaticContentItemDown({ contentItemId: this.value.Id, tenantName: this.tenantName })
          this.setSnackbar({
            text: 'Updated static content item order successfully',
            icon: 'done',
            color: 'success',
          })
        } catch (ex) {
          this.setSnackbar({
            text: `Failed to update static content item ordering: ${ex}`,
            icon: 'error',
            color: 'error',
          })
          console.error(ex)
        }
      },
    },
  }
</script>

<style scoped>
  .tile-content {
    background-color: white;
  }

  .tile-background {
    background-color: #999999;
  }

  button.edit-action-button {
    align-self: center;
    flex: 0 0;
  }
</style>